import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useLocale } from "next-intl";
import { useAnyTranslations } from "@lib/i18n/utils";
import { type ChartDataPoint, type EntitiesChartMetrics, aggregateByMonth, calculateDisplayMetrics, extractEntityTimestamps, filterSignificantPeriods, generateChartData } from "@features/events-program/ui/widgets/proposals-count-by-month-stats-widget/chart-data-processor";
export interface ProposalChartData {
  chartData: ChartDataPoint[];
  metrics: EntitiesChartMetrics;
  isEmpty: boolean;
  isLoading: boolean;
}

/**
 * Custom hook for processing proposal data into chart-ready format
 * with smart filtering and trend analysis
 */
export function useProposalChartData(proposals) {
  const $ = _c(15);
  const locale = useLocale();
  const tAny = useAnyTranslations("features.events-program.ui.widgets.proposalsStatsWidget");
  let t0;
  bb0: {
    if (!proposals) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          chartData: [],
          metrics: {
            totalProposals: 0,
            timeRange: "",
            trend: "stable",
            trendPercentage: 0,
            mostActiveMonth: "",
            averagePerMonth: 0,
            showChart: false
          },
          isEmpty: true,
          isLoading: true
        };
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== locale || $[2] !== proposals || $[3] !== tAny) {
      t1 = calculateDisplayMetrics(proposals, locale, tAny);
      $[1] = locale;
      $[2] = proposals;
      $[3] = tAny;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    const metrics = t1;
    if (!metrics.showChart) {
      let t2;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[5] = t2;
      } else {
        t2 = $[5];
      }
      const t3 = metrics.totalProposals === 0;
      let t4;
      if ($[6] !== metrics || $[7] !== t3) {
        t4 = {
          chartData: t2,
          metrics,
          isEmpty: t3,
          isLoading: false
        };
        $[6] = metrics;
        $[7] = t3;
        $[8] = t4;
      } else {
        t4 = $[8];
      }
      t0 = t4;
      break bb0;
    }
    let t2;
    if ($[9] !== locale || $[10] !== proposals) {
      const timestamps = extractEntityTimestamps(proposals);
      const monthlyData = aggregateByMonth(timestamps, locale);
      const filteredData = filterSignificantPeriods(monthlyData, locale);
      t2 = generateChartData(filteredData);
      $[9] = locale;
      $[10] = proposals;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    const chartData = t2;
    let t3;
    if ($[12] !== chartData || $[13] !== metrics) {
      t3 = {
        chartData,
        metrics,
        isEmpty: false,
        isLoading: false
      };
      $[12] = chartData;
      $[13] = metrics;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t0 = t3;
  }
  return t0;
}